import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Firebase, currentUserRole, isProduction, appConfig } from './../../util';

import { Redirect, withRouter, Link } from 'react-router-dom';
import qs from 'qs';

class ResetPassword extends Component {

  state = {
    email: '',
    password: '',
    formError: null,
    formMessage: null,
    syncingWithServer: false,
    invalidResetCode: false,
    code: null,
    continueUrl: '/login',
    resetComplete: false,
    confirmingSigninLink: false,
    signInComplete: false,
  }

  handeLinkSigninIfPresent(){
    //https://firebase.google.com/docs/auth/web/email-link-auth

    // Confirm the link is a sign-in with email link.
    if (Firebase.auth().isSignInWithEmailLink(window.location.href)) {
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.


      this.setState({
        confirmingSigninLink: true
      });

      var email = window.localStorage.getItem('velocity_email_for_signin_link');

      if(email){
        this.setState({ email });
        this.completeSignInWithEmailLink(email);
      }
      else{
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        //email = window.prompt('Please provide your email for confirmation');
      }
    }
  }

  completeSignInWithEmailLink(email = this.state.email){

    let self = this;

    self.setState({
      syncingWithServer: true
    });

    // The client SDK will parse the code from the link for you.
    Firebase.auth().signInWithEmailLink(email, window.location.href)
      .then(function(result) {
        // Clear email from storage.
        window.localStorage.removeItem('velocity_email_for_signin_link');
        // You can access the new user via result.user
        // Additional user info profile not available via:
        // result.additionalUserInfo.profile == null
        // You can check if the user is new or existing:
        // result.additionalUserInfo.isNewUser

        //redirect handled when this is set to true by going to continueUrl (set in componentDidMount)
        self.setState({
          signInComplete: true
        });
      })
      .catch(function(error) {
        // Some error occurred, you can inspect the code: error.code
        // Common errors could be invalid email and invalid or expired OTPs.
        console.error(error);
        self.setState({
          formError: error.message,
          syncingWithServer: false
        });
      });
  }

  componentDidMount(){

    this.passwordInput.focus();

    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    let continueUrl = '/login';
    let code = '';

    if(params.oobCode){
      code = params.oobCode;
    }
    if(params.continueUrl){
      continueUrl = params.continueUrl;
    }

    this.setState({
      code,
      continueUrl,
    });

    this.verifyCode(code);

    this.handeLinkSigninIfPresent();
  }

  verifyCode(code){
    Firebase.auth().verifyPasswordResetCode(code).then(() => {

    }).catch(err => {
      this.setState({
        invalidResetCode: true,
        formError: this.state.confirmingSigninLink ? 'Sign-in link invalid or expired.' : 'Reset password link contains invalid code. Please reset password and try again.'
      });
    })
  }

  submitForm(){
    this.setState({
      syncingWithServer: true,
      formError: false
    });

    Firebase.auth().confirmPasswordReset(this.state.code, this.state.password).then(() => {


      this.setState({
        formMessage: 'Password updated! Redirecting to login page...'
      });

      //redirect after timeout
      setTimeout(() => {
        this.setState({
          resetComplete: true
        });
      }, 3000);
    }).catch(err => {

      this.setState({
        syncingWithServer: false,
        formError: err.message
      });
    });
  }

  getButtonHtml(){
    if(this.state.confirmingSigninLink){
      return {
        __html: (this.state.syncingWithServer ? 'Verifying Email...' : 'Complete Sign In')
      };
    }
    else{
      return {
        __html: (this.state.syncingWithServer ? 'Updating...' : 'Update password')
      };
    }
  }

  handleSubmit(event){
    event.preventDefault();
  }

  bodyForm(){

    const { confirmingSigninLink, password, syncingWithServer, formError, formMessage, invalidResetCode, email, continueUrl } = this.state;

    if(invalidResetCode){
      return (
        <div className="velocity-form page-form">
          <div className="form-message error">{formError}</div>
          <p style={{fontSize: '18px', textAlign: 'center', width: '100%', marginTop: '25px'}}>Click the button below to try again.</p>
          {confirmingSigninLink &&
            <a href={`${continueUrl ? continueUrl : '/a/default'}`}>
              <button style={{marginTop: '15px', width: '100%'}} className="button primary">Try again...</button>
            </a>
          }
          {!confirmingSigninLink &&
            <Link to="/login?forgot=true">
              <button style={{marginTop: '15px', width: '100%'}} className="button primary">Reset Password...</button>
            </Link>
          }
        </div>
      );
    }
    else{
      return (
        <form onSubmit={this.handleSubmit.bind(this)}>
          <div className="velocity-form page-form">
            <h2>{!confirmingSigninLink ? 'Create new Password' : 'Confirm email address'}</h2>

            {formError &&
              <div className="form-message error">{formError}</div>
            }
            {formMessage &&
              <div className="form-message success">{formMessage}</div>
            }

            {confirmingSigninLink &&
              <React.Fragment>
                <div className="form-group">
                  <label htmlFor="velocity-login-email">Email</label>
                  <input
                    ref={input => { this.emailInput = input; }}
                    id="velocity-login-email"
                    disabled={syncingWithServer || invalidResetCode}
                    type="text"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => this.setState({ email: e.target.value }) }
                  />
                </div>

                <div className="form-group">
                  <button className={'button primary' + ((syncingWithServer || invalidResetCode) ? ' disabled' : '')} disabled={syncingWithServer} onClick={() => { this.completeSignInWithEmailLink() } } dangerouslySetInnerHTML={this.getButtonHtml()}></button>
                </div>
              </React.Fragment>
            }

            {!confirmingSigninLink &&
              <React.Fragment>
                {email &&
                  <p>{email}</p>
                }
                <div className="form-group">
                  <label htmlFor="velocity-login-password">New Password</label>
                  <input ref={input => { this.passwordInput = input; }} id="velocity-login-password" disabled={syncingWithServer || invalidResetCode} type="password" placeholder="Password" value={password} onChange={(e) => this.setState({ password: e.target.value }) } />
                </div>

                <div className="form-group">
                  <button className={'button primary' + ((syncingWithServer || invalidResetCode) ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitForm.bind(this)} dangerouslySetInnerHTML={this.getButtonHtml()}></button>
                </div>
              </React.Fragment>
            }

          </div>
        </form>
      );
    }
  }

  render() {

    //only redirect after user prop updates in store
    if (this.state.resetComplete || this.state.signInComplete) {
      //hard redirect to continue url
      document.location = this.state.continueUrl;
      return null;
      //return <Redirect to={this.state.continueUrl} />
    }

    return (
      <div className="page login">
        {this.bodyForm()}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    authenticated: (state.user && state.user.uid) ? true : false
  }
}

export default withRouter(connect(mapStateToProps, {})(ResetPassword));



// WEBPACK FOOTER //
// ./src/components/resetPassword/index.js